import { FunctionComponent } from 'react';
import * as geoMatchSlice from './reducer/geoMatchSlice';
import { useAppSelector } from '../../app/hooks';

import Button from '@designSystem/Button';
import Card from '@designSystem/Card';
import HeaderCardCustom from '../eligibility/HeaderCardCustom';
import SearchByAddress from '../eligibility/search/SearchByAddress';
import { useTranslation } from 'react-i18next';
import { SelectAddressMapWrapper, SelectAddressWrapperInput } from './styles/SelectAddress';

const GeoMatchSelectAddress: FunctionComponent<{
  nextStep: () => void;
}> = ({ nextStep }) => {
  const { t } = useTranslation();
  const searchInfos = useAppSelector(geoMatchSlice.selectSearchInfos);

  return (
    <SelectAddressMapWrapper>
      <Card
        header={
          <HeaderCardCustom
            titleHeader={t('features.geomatch.choosePlace', 'Search for an address')}
            subTitleHeader={t(
              'features.geomatch.searchAddress',
              `Select the address on which you would like to make the comparison between the IPE and the BAN addresses: 
              If the city you chose didn't entered its addresses in the BAN, the comparison will be impossible.`
            )}
          />
        }
        footer={
          <Button
            style={{
              marginLeft: 'auto'
            }}
            disabled={!searchInfos.type}
            onClick={nextStep}
            data-testid={'select-options-list_next-step'}
          >
            {t('component.button.nextStep', 'Next step')}
          </Button>
        }
      >
        <SelectAddressWrapperInput>
          <SearchByAddress sliceModule={geoMatchSlice} />
        </SelectAddressWrapperInput>
      </Card>
    </SelectAddressMapWrapper>
  );
};

export default GeoMatchSelectAddress;
